import {
  SPORTS_LOAD,
  SPORTS_LOAD_SUCCESS
} from './actions';

const initialState = {
  sportsJson: null
};

export function sportsReducer(state = initialState, action) {
  let data = action.payload;

  switch (action.type) {
    case SPORTS_LOAD:
      return {
        ...state,
        sportsJson: null
      };

    case SPORTS_LOAD_SUCCESS:
      return {
        ...state,
        sportsJson: data
      };

    default:
      return state;
  }
}
